import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { FAQResponse } from '../models/faqs.model';
import { FAQRepository } from '../repositories/faqs.repository';

export class getFAQsUseCase implements UseCase<void, FAQResponse> {
    constructor(private readonly repository: FAQRepository) {}

    execute(): Observable<FAQResponse> {
        return this.repository.getFAQs();
    }
}
